module.exports = __webpack_public_path__ + "static/img/image17.48b7d8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image17.png
// module id = 6an6
// module chunks = 1